module.exports = __webpack_public_path__ + "static/media/mr1.ea3aade.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/video/mr1.mp4
// module id = xYPq
// module chunks = 12